import { FormGroup } from '@angular/forms';
import { MarketingPreferencesForm } from './marketing-preferences-form.interface';

export type MarketingPreferencesFormValue = ReturnType<
  FormGroup<MarketingPreferencesForm>['getRawValue']
>;
